import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "39",
  height: "73",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M38.6.401H.4v43.987h38.2V.401ZM35.399 3.6v37.588H3.6V3.6h31.799Z\"></path><path d=\"M12.424.809 38.068 23.8l-2.136 2.382L10.288 3.191z\"></path><path d=\"m23.05 12.36 2.255 2.271L3.24 36.544l-2.255-2.27zM21.1 42.788v28.41h-3.2v-28.41z\"></path><path d=\"M33.804 69.598v3.2H5.196v-3.2z\"></path></g>", 1)
  ])))
}
export default { render: render }